import React from 'react';

const PrintHeader = ({entity, title, className = "", customSubTitle = null, titleClassName}) => {
    const address = [
            entity?.address,
            entity?.number && (entity?.address ? ", " : "") + entity?.number,
            entity?.neighborhood && (entity?.address || entity?.number ? ", " : "") + entity?.neighborhood,
            entity?.city && (entity?.address || entity?.number || entity?.neighborhood ? ", " : "") + entity?.city,
        ].filter(Boolean).join('')

    return (
        <header className={className}>
            <div className="flex justify-between items-center w-full relative h-[105px]">
                <div className="w-25 h-22.25 z-[9] absolute">
                    <img src={entity?.imagePath} className={"h-full w-full object-contain"} alt="img corporação"/>
                </div>

                <div className="w-full space-y-1">
                    <p className="text-[5.5mm] font-bold text-center w-full block">{entity?.name}</p>
                    <p className="text-center w-full font-light text-[2.7mm]">{address}</p>
                    <p className={`w-full uppercase z-[1] text-center ${titleClassName}`}>{title}</p>
                    { customSubTitle && ( <p className="w-full uppercase z-[1] text-center">{customSubTitle}</p> )}
                </div>
            </div>

            <div className="border-b border-gray-200 w-full print:mb-[5mm]"/>
        </header>
    );
};

export default PrintHeader;